"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var text = 'text';
var dropdown = 'dropdown';
var image = 'image';
var number = 'number';
var multiSelect = 'multiSelect';
var date = 'date';
var block = 'block';
var barcode = 'barcode';
var signature = 'signature';
var _default = exports["default"] = {
  text: text,
  dropdown: dropdown,
  image: image,
  number: number,
  date: date,
  block: block,
  multiSelect: multiSelect,
  barcode: barcode,
  signature: signature
};